import React from 'react';
import Banner from '../../../components/Banner/Banner';
import ProductTable from '../../../components/ProductTable/ProductTable';
import './Molybdenum.css';

const Molybdenum = () => {
  // Data for first table
  const table1Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table1Rows = [
    [
      { content: "TKN <br>Mo1MC05" },
      { content: "Rs &lt; 1 ohm/kare<br>25 mm x 50 mm<br>1.0 mm kalınlık<br><br>1 Paket, 5 adet cam ihtiva eder<br><br>Tek yüzeyi kaplamalıdır<br><br>Yüzeye yapışma mukavemeti <br>Scotch tape ile kontrol edilmiştir" },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">2396</span></strong>" },
    ]
  ];
  
  // Data for second table
  const table2Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table2Rows = [
    [
      { content: "TKN <br>Mo1MC20" },
      { content: "Rs &lt; 1 ohm/kare<br>25 mm x 50 mm<br>1.0 mm kalınlık<br><br>1 Paket, 20 adet cam ihtiva eder<br><br>Tek yüzeyi kaplamalıdır<br><br>Yüzeye yapışma mukavemeti <br>Scotch tape ile kontrol edilmiştir" },
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">8628</span></strong>" },
    ]
  ];
  
  // Data for third table
  const table3Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table3Rows = [
    [
      { content: "TKN <br>Mo1MC50" },
      { content: "Rs &lt; 1 ohm/kare<br>25 mm x 50 mm<br>1.0 mm kalınlık<br><br>1 Paket, 50 adet cam ihtiva eder<br><br>Tek yüzeyi kaplamalıdır<br><br>Yüzeye yapışma mukavemeti <br>Scotch tape ile kontrol edilmiştir" },
      { content: "<span style=\"color: #000000;\"><strong>50</strong></span>" },
      { content: "<span style=\"color: #000000;\"><strong>19412</strong></span>" },
    ]
  ];
  
  return (
    <>
      <Banner title="Molibdenyum Kaplamalar" />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="molybdenum-content">
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)</h4>
                      <ProductTable 
                        title="Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)"
                        headers={table1Headers}
                        rows={table1Rows}
                        className="table-1"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)</h4>
                      <ProductTable 
                        title="Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)"
                        headers={table2Headers}
                        rows={table2Rows}
                        className="table-2"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)</h4>
                      <ProductTable 
                        title="Molibdenyum Kaplı Mikroskop Camı (900-1100 nm, bilayer)"
                        headers={table3Headers}
                        rows={table3Rows}
                        className="table-3"
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Molybdenum;